import request from '@/utils/request'
import baseUrl from '@/api/baseUrl'

export default {
	/**
	 * 井盖日志列表
	 * @param {page} 第几页
	 * @return {pageSize} 每页数量
	**/
	manholeLogList( params={} ) {
		return request({
	    url: baseUrl + '/device/manhole/log',
	    method: 'GET',
	    params
	  })
	}
}